import React, { useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import EmailEditor from 'react-email-editor';

const EmailEditorForEmailTemplate = forwardRef(({ JSONDesign,handleSetEmailTemplateBody }, ref) => {
  const emailEditorRef = useRef(null);
useEffect(()=>{
    console.log("SEKARRRRRRRRRR",JSONDesign)
},[])
//   const saveDesign = () => {
//     if (emailEditorRef.current) {
//       emailEditorRef.current.editor.saveDesign((design) => {
//         console.log('saveDesign', design);
//         localStorage.setItem("design", JSON.stringify(design)); // Save the design to local storage
//       });
//     } else {
//       console.error('EmailEditor ref is not defined');
//     }
//   };

  useImperativeHandle(ref, () => ({
    exportHtml: () => {
      return new Promise((resolve, reject) => {
        if (emailEditorRef.current) {
            emailEditorRef.current.editor.saveDesign((design) => {
                console.log('saveDesign', design);
                 // Save the design to local storage
              });
          emailEditorRef.current.editor.exportHtml((data) => {
            // localStorage.setItem("design", JSON.stringify(data.design));
            console.log("Expected Data", data);
            const { html,design} = data;
            if (html) {
              handleSetEmailTemplateBody(html); // Call the passed function to set HTML
              console.log("JSON", data.design);
              console.log("HTML", html);
              resolve({ html ,design}); // Resolve both HTML and JSON
            } else {
              reject('Failed to export HTML');
            }
          });
        } else {
          reject('EmailEditor ref is not defined');
        }
      });
    },
    removeUnwantedElements: () => {
      if (emailEditorRef.current) {
        // Example: Remove all unlayed elements
        const unlayedElements = emailEditorRef.current.editor.getUnlayedElements(); // Assuming this method exists
        unlayedElements.forEach((element) => {
          emailEditorRef.current.editor.removeElement(element.id); // Assuming you can remove by id
        });
      }
    },
  }));

  const onLoad = () => {
    const json = JSONDesign;
    if (json) {
      emailEditorRef.current.editor.loadDesign(json); // Load the design from local storage
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const unlayerLabel = document.querySelector('.powered-by');
      if (unlayerLabel) {
        unlayerLabel.style.pointerEvents = 'none';
        clearInterval(interval);
      }
    }, 500); // Check every 500ms until found, then stop
  }, []);
  

  return (
    <div>
      {/* <button onClick={saveDesign}>Save Design</button> */}
      <EmailEditor ref={emailEditorRef} onLoad={onLoad} 
      
      
      />
    </div>
  );
});

export default EmailEditorForEmailTemplate;
